export default {"src":"/_next/static/media/close-white.bae2985a.svg","height":16,"width":16};